module.exports = __webpack_public_path__ + "img/L2_open.24ae56e8.svg";